import React, { Fragment, FunctionComponent } from 'react';
import { WPAcfPeople } from 'types/acf/people';
import PeopleBlock from './PeopleBlock';

interface OwnProps {
  data: WPAcfPeople | null;
}

type PeopleProps = JSX.IntrinsicElements['div'] & OwnProps;

const People: FunctionComponent<PeopleProps> = props => {
  const { data } = props;

  if (!data || !data.teams) {
    return null;
  }

  const { teams } = data;

  return (
    <Fragment>
      {teams &&
        teams.map((team, index) => {
          if (!team?.members) {
            return null;
          }
          return <PeopleBlock key={`people-team-${index}`} teamIndex={index} team={team} />;
        })}
    </Fragment>
  );
};

export default People;
